// @flow

import activeLanguage from './reducer';

export {
  setActiveLanguage,
  setActiveLanguageCookie,
  switchActiveLanguage,
} from './actions';
export { getActiveLanguage } from './selectors';
export type { State, ActiveLanguage } from './types';
export default activeLanguage;
